export default __webpack_public_path__ + "static/media/Multiselect_Uncheck_Icon.0229596a.svg";